import React from "react";
import {FormattedMessage} from "react-intl";
import {clearStorageItems, findMobileOperatingSystemAndGetLink} from "../../util/common";
import {PATH} from "../../routes/routes.js";
import {useNavigate} from "react-router";

function ThankYouActionsBar(props) {
    const navigateTo = useNavigate();
    const clearStorageAndRedirect = () => {
      clearStorageItems();
      navigateTo(PATH.ALL_PRODUCTS);
    }
    return (
        <div className={props.isVisible ?
            "actionsbar static thank-you-actions-bar show"
            : "actionsbar static"}>
            <div className="banner campaigns-banner">
                {props.showDownloadApp &&<div className="row">
                    <p><FormattedMessage id="GetAnEvenBetterOrdering"/></p>
                    <a target="_blank" href={findMobileOperatingSystemAndGetLink()} className="btn btn-special"><FormattedMessage id="GetApp"/></a>
                </div>}
            </div>
            <div className="row buttons-row">
                <button className={props.btnClassName} onClick={clearStorageAndRedirect}>
                    {props.btnName}
                </button>

            </div>
        </div>


    );
}

export default ThankYouActionsBar;
